export default __webpack_public_path__ + "static/media/developer.ef097afb.svg";